import { useState } from "react";
import { transformExtent } from "ol/proj";
import FileUploadComponent from "../../fileupload/fileUploadComponent";
import {
  addLayer,
  formatGEOJSONLayer,
  getLayerIdByName,
  key,
  trans,
} from "../../../lib/utils";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import store from "../../../stores/store";
import md5 from "md5";
import { getAttributesFromGeoJSON } from "../../../lib/featureUtils";

let geojsonExtent = require("geojson-bbox");

function DXF(props) {
  const [title, setTitle] = useState(null);
  const [fileRequiresExtraInfo, setFileRequiresExtraInfo] = useState(false);
  const [fileProjection, setFileProjection] = useState(
    window["appConfig"]()["projectionSystems"][0].code
  );
  const [fileEncoding, setFileEncoding] = useState(
    window["appConfig"]()["charsets"][0].value
  );
  const [fileGeoJSON, setFileGeoJSON] = useState(null);

  function disableBtn() {
    return title ? false : true;
  }

  return (
    <PerfectScrollbar
      style={{ height: "calc(100vh - 27rem)" }}
      className="pe-3"
    >
      <div className="mb-3 ">
        <label className="color-get-blue strong ">
          {trans("Type a layer name")}
        </label>
        <div className="mt-2 input-group">
          <input
            type="text"
            className="form-control small"
            placeholder={trans("Type a layer name")}
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          ></input>
        </div>
      </div>
      <div className="mb-3">
        <FileUploadComponent
          placeholder={trans("Allowed file extension: dxf")}
          allowedExtensions={["dxf"]}
          onDropFeatures={(geoJson, ext, fileName) => {
            if (!geoJson.hasPrjFile) {
              setFileRequiresExtraInfo(true);
            }

            const bbox = geojsonExtent(geoJson);

            let randomColor = Math.floor(Math.random() * 16777215).toString(16);

            setFileGeoJSON({
              geoJson: geoJson,
              color: randomColor,
              bbox: bbox,
              fileName: fileName,
              legend: window["appConfig"]()["api"](
                "?proxy=color&color=".concat(randomColor)
              ),
            });
          }}
        ></FileUploadComponent>
      </div>
      {fileGeoJSON ? (
        <div className="mb-3">
          <label className="color-get-blue strong d-block">
            {trans("Layer legend")}
          </label>
          <img
            src={fileGeoJSON.legend}
            width="40"
            height="40"
            className="mt-3"
          />
        </div>
      ) : (
        ""
      )}
      <div className="mb-3">
        <span className="color-get-blue ">
          <strong>{fileGeoJSON ? trans("File uploaded!") : ""}</strong>
        </span>
      </div>
      {fileRequiresExtraInfo ? (
        <>
          {/* <div className="mb-3">
            <span className=" bg-warning text-dark  p-2 rounded">
              <i className="fas fa-exclamation-triangle me-2"></i>No prj file
              detected!
            </span>
          </div> */}
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Select projection system")}
            </label>
            <div className="mt-2 input-group">
              <select
                className="form-select form-select-sm "
                value={fileProjection}
                onChange={(e) => {
                  setFileProjection(e.target.value);
                }}
              >
                {window["appConfig"]()["projectionSystems"].map((opt) => {
                  return <option value={opt.code}>{opt.title}</option>;
                })}
              </select>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {/* fileGeoJSON ? (
        <div className="mb-3">
          <label className="color-get-blue strong ">
            Detected projection system
          </label>
          <div className="mt-2 ">{fileGeoJSON.service.url.prj}</div>
        </div>
      ) : (
        ""
      )} */}

      {fileGeoJSON ? (
        <>
          {/* <div className="mb-3">
            <label className="color-get-blue strong ">
              Select character encoding
            </label>
            <div className="mt-2 input-group">
              <select
                className="form-select form-select-sm "
                value={fileEncoding}
                onChange={(e) => {
                  setFileEncoding(e.target.value);
                }}
              >
                {window["appConfig"]()["charsets"].map((opt) => {
                  return <option value={opt.value}>{opt.label}</option>;
                })}
              </select>
            </div>
          </div> */}
          <div className="mb-3 text-end">
            <button
              className=" btn btn-sm btn-success small"
              disabled={disableBtn()}
              onClick={() => {
                let source = {
                  id: md5(JSON.stringify(fileGeoJSON.geoJson)),
                  type: "GEOJSON",
                  name: "DXF",
                  title: fileGeoJSON.fileName,
                  url: JSON.stringify(fileGeoJSON.geoJson),
                };

                store.dispatch({
                  type: "source/add",
                  payload: { [source.id]: source },
                });

                let bbox = transformExtent(
                  fileGeoJSON.bbox,
                  fileProjection,
                  "EPSG:4326"
                );

                let layer = formatGEOJSONLayer({
                  id: getLayerIdByName(fileGeoJSON.fileName, source.url),
                  name: fileGeoJSON.fileName,
                  title: title,
                  attributes: getAttributesFromGeoJSON(fileGeoJSON.geoJson),
                  projection: fileProjection,
                  legend: fileGeoJSON.legend,
                  color: fileGeoJSON.color,
                  bbox: bbox,
                  abstract: "DXF File ".concat(fileGeoJSON.fileName),
                });

                layer.source = source;

                addLayer(layer);

                store.dispatch({
                  type: "layer/registeredlayertree/add",
                  payload: layer,
                });
              }}
            >
              <span className="text-white">
                <i className="fas fa-plus  me-2"></i>
                {trans("Add to map")}
              </span>
            </button>
          </div>
        </>
      ) : (
        ""
      )}
    </PerfectScrollbar>
  );
}
export default DXF;
